define.alias("shared/components/shared/upgrade/trial-monthly-price", "media/components/shared/upgrade/trial-monthly-price");